<template>
  <main>
    <van-nav-bar
        title="客户信息收集"
        left-text="返回"
        left-arrow
        :right-text="this.xgtj===true?'删除':''"
        @click-left="back"
        @click-right="deleteKhxx"
    />
  <van-form @submit="onSubmit">
    <van-field
        v-model.trim="form.unitName"
        name="kpName"
        maxlength="40"
        required
        label="商铺名称"
        placeholder="商铺名称"
        @blur="nameSyn"
    />
    <van-field
      v-model.trim="form.khName"
      name="kpName"
      maxlength="40"
      required
      label="开票名称"
      placeholder="开票名称"
    />
    <van-field
      v-model.trim="form.khNsrsbh"
      name="khNsrsbh"
      maxlength="20"
      label="开票税号"
      placeholder="开票税号"
    />
    <van-field
      v-model.trim="form.khlx"
      name="khCustkind"
      is-link
      readonly
      required
      label="客户类型"
      placeholder="客户类型"
      @click="show = true"
    />
    <van-popup v-model="show" round position="bottom">
      <van-cascader
        v-model.trim="form.industryId"
        title="所在行业"
        :options="options"
        @close="show = false"
        @finish="onFinish"
      />
    </van-popup>
  <van-field
      v-model.trim="form.zcdz"
      name="corpNsrsbh"
      is-link
      readonly
      required
      maxlength="100"
      label="客户地址"
      placeholder="客户地址"
       @click="setAddRessOpen()"
  />
  <van-popup v-model="addressShow" round position="bottom">
    <van-cascader
        v-model.trim="form.dzShreet"
        title="所在街道"
        :options="addressOptions"
        @close="addressShow = false"
        @change="onAddressChange"
        @finish="onAddressFinish"
    />
  </van-popup>
       <van-field
      v-model.trim="form.dzXxdz"
      name="corpDzdh"
      maxlength="150"
      required
      label="详细地址"
      placeholder="详细地址"
    />
    <van-field
      v-model.trim="form.contactNumber"
      name="phone"
      label="商户手机号"
      required
      maxlength="11"
      placeholder="商户手机号"
    >
    </van-field>
  <van-field
    v-model.trim="form.standards"
    name="phone"
    label="收费标准"
    required
    readonly
    placeholder="收费标准"
    @click="moneyShow=true"
  ></van-field>
  <van-field
      v-model.trim="form.mail"
      name="mail"
      label="收票邮箱"
      maxlength="50"
      required
      placeholder="收票邮箱"
    />
  <van-field
      v-model.trim="form.waterMeterNo"
      type="digit"
      name="numberOfUnits"
      label="水表号"
      maxlength="20"
      placeholder="水表号"
  />
  <van-field
      v-model="form.landlordSname"
      type="digit"
      name="landlordSname"
      label="房东姓名"
      maxlength="20"
      placeholder="房东姓名"
  />
  <van-field
      v-model="form.landlordTelephone"
      type="digit"
      name="landlordTelephone"
      maxlength="11"
      label="房东手机号"
      placeholder="房东手机号"
  />
  <van-field
      v-model="form.remarks"
      label="备注"
      maxlength="100"
      placeholder="备注" />
      <van-popup v-model="moneyShow" position="bottom" >
        <van-picker
          title="规格/价格"
          show-toolbar
          :columns="moneyColumns"
          @confirm="moneyConfirm"
          @cancel="moneyShow = false"
        />
      </van-popup>
      <div style="margin: 16px;">
        <van-button round block type="primary" native-type="submit" style="margin-bottom: 65px;">
          {{this.xgtj===true?"修改":"提交"}}
        </van-button>
      </div>
    </van-form>
  </main>
</template>
<script>
import Vue from "vue";
import {
  Col, Row,
  ActionSheet,
  Button,
  Collapse,
  CollapseItem,
  Field,
  Form,
  Cell, 
  CellGroup,
  Icon,
  NavBar,
  Radio,
  RadioGroup,
  Sticky,
  Tab,
  Tabs,
  Toast,
  Search,
  Picker,
  Dialog,
  Cascader
} from "vant";
Vue.use(Col);
Vue.use(Row);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Field);
Vue.use(Form);
Vue.use(NavBar);
Vue.use(ActionSheet);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Radio );
Vue.use(RadioGroup);
Vue.use(Sticky);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Search);
Vue.use(Picker);
Vue.use(Dialog);
Vue.use(Cascader)
export default {

data() {
  return {
    show:false,
    addressShow: false,
    showPicker:false,
    showPickerYear:false,
    moneyShow: false,
    xgtj:false,
    options:[],
    addressOptions:[],
    moneyColumns:[],
    sysarea: {parentId:'350800',delFlag:'0'},
    form:{
      khName:'',
      khNsrsbh:'',
      khlx:'',
      khCustkind:'',
      industryId:'',
      zcdz:'',
      dzCounty:'',
      dzShreet:'',
      dzXxdz:'',
      contactNumber: '',
      money:'',
      standards:'',
      mail:'',
      waterMeterNo:'',
      landlordSname:'',
      landlordTelephone:'',
      remarks:'',
      confirmStatus:'',
      addUserid:'',
      unitName:''
    },
    columns: ['电票', '专票', '普票'],
    columnsYear:['2022','2023','2024','2025','2026','2027','2028','2029','2030','2031',
      '2032','2033','2034','2035','2036',
    ]
  }
},
  mounted() {
    this.init()
  },
  methods: {
    //默认选择新罗区
    setAddRessOpen(){
        this.addressShow=true;
        this.form.dzShreet='350802';
          this.$axios
          .get('/memberBusiness/sysArea/sysareaList', {parentId:'350802',delFlag:'0'})
          .then((data) => {
           this.addressOptions[0].children = [];
            data.obj.forEach((a)=>{
               this.addressOptions[0].children.push({text:a.name,value:a.id})
            })
           
          })
          .catch(
              function (response) {
                this.$message.error('操作失败请重试');
              }.bind(this)
          );
    },
    moneyConfirm(item){
      this.form.standards = item.text
      this.form.money = item.price
      this.moneyShow = false
    },
    onAddressChange(item){
      console.log()
      this.$axios
          .get('/memberBusiness/sysArea/sysareaList', {parentId:item.selectedOptions[0].value,delFlag:'0'})
          .then((data) => {
            const children = [];
            console.log(data)
            data.obj.forEach((a)=>{
              children.push({text:a.name,value:a.id})
            })
            item.selectedOptions[0].children=children
          })
          .catch(
              function (response) {
                this.$message.error('操作失败请重试');
              }.bind(this)
          );
    },
    onFinish({selectedOptions}){
      this.form.standards="";
      var that = this
      this.show = false;
      this.form.khlx=selectedOptions.map((option) => option.text).join('/');
      this.form.khCustkind = selectedOptions[0].value
      this.form.industryId = selectedOptions[1].value
      this.$axios.get("/index/"+this.form.industryId+"/selectSku").then((data) => {
        that.moneyColumns = []
        console.log("??"+data)
        data.data.forEach((a)=>{
          that.moneyColumns.push({text:a.skuTitle+"，单价:"+a.skuPrice,value:a.id,price:a.skuPrice})
        })
      }).catch(
          function (response) {
            this.$message.error('操作失败请重试');
          }.bind(this)
      );
    },
    onAddressFinish({selectedOptions}){
      this.addressShow = false;
      this.form.zcdz=selectedOptions.map((option) => option.text).join('/');
      this.form.dzCounty = selectedOptions[0].value
      this.form.dzShreet = selectedOptions[1].value

    },
    init(){
      var that = this;
      this.$axios
          .get('/index/trees',{by1:"1"})
          .then((data) => {
            data.data.forEach((a)=>{
              const children = [];
              a.children.forEach((e)=>{
                children.push({text:e.label,value:e.id})
              })
              that.options.push({text:a.label,value:a.id,children:children})
            })
          })
          .catch(
              function (response) {
                this.$message.error('操作失败请重试');
              }.bind(this)
          );
      this.$axios
          .get('/memberBusiness/sysArea/sysareaList',this.sysarea)
          .then((data) => {
            data.obj.forEach((a)=>{
              that.addressOptions.push({text:a.name,value:a.id,children:[]})
            })
          })
          .catch(
              function (response) {
                this.$message.error('操作失败请重试');
              }.bind(this)
          );
      if(sessionStorage.getItem("sjrymx")!=null){
        this.xgtj = true
        this.$axios
            .get("/memberBusiness/customer/customerList",{id:sessionStorage.getItem("sjrymx")}).then((data) => {
          sessionStorage.removeItem("sjrymx");
          if (data.code == 0) {
            const das = data.obj[0];
            that.form={
                  khName:das.khName,
                  khNsrsbh:das.khNsrsbh,
                  khlx:das.khlx+'/'+das.industry,
                  khCustkind:das.khCustkind,
                  industryId:das.industryId,
                  zcdz:das.zcdz,
                  dzCounty:das.dzCounty,
                  dzShreet:das.dzShreet,
                  dzXxdz:das.dzXxdz,
                  contactNumber: das.contactNumber,
                  mail:das.mail,
                  waterMeterNo:das.waterMeterNo,
                  landlordSname:das.landlordSname,
                  landlordTelephone:das.landlordTelephone,
                  remarks:das.remarks,
                  id:das.id,
                  money:das.money,
                  standards:das.standards,
                  confirmStatus:das.confirmStatus,
                  addUserid:das.addUserid,
                  unitName:das.unitName
            }
            this.$axios.get("/index/"+that.form.industryId+"/selectSku").then((data) => {
              that.moneyColumns = []
              data.data.forEach((a)=>{
                that.moneyColumns.push({text:a.skuTitle+"，单价:"+a.skuPrice,value:a.id,price:a.skuPrice})
              })
            }).catch(
                function (response) {
                  this.$message.error('操作失败请重试');
                }.bind(this)
            );
          }
        })
      }
    },
    deleteKhxx(){
      Dialog.confirm({
        title: '删除提醒',
        message: '是否删除该条客户信息',
      })
          .then(() => {
            this.$axios
                .post("/memberBusiness/customer/deleteCustomer",this.form.id).then((data) => {
              if(data.code==0){
                this.$router.push({ path: "/customerList" });
                Toast('删除成功');
              }else{
                Toast('删除失败');
              }
            });
          })
          .catch(() => {
            // on cancel
          });
    },
    nameSyn(){
      this.form.khName = this.form.unitName
    },
    back(){
      this.$router.push({ path: "/customerList" });
    },
    onConfirmYear(value){
      this.form.year = value;
      this.showPickerYear = false;
    },
    onConfirm(value){
      this.form.fplx = value;
      this.showPicker = false;
    },
    updateStatus(){
      //先判断发票类型
      if(this.form.kpName===''){
        Toast("商铺名称不能为空");
        return ;
      }
      if(this.form.khlx===''){
        Toast("所在行业不能为空");
        return ;
      }
      if(this.form.zcdz===''){
        Toast("客户地址不能为空");
        return ;
      }
      if(this.form.standards===''){
        Toast("收费标准不能为空")
        return;
      }
      if(this.form.dzXxdz === ''){
        Toast("详细地址不能为空")
        return;
      }
      if(this.form.khlx === ''){
        Toast("客户类型不能为空")
        return;
      }

      if(this.form.mail===''){
        Toast("邮箱不能为空");
        return ;
      }
      if(this.form.khNsrsbh!==''){
        var idReg = /(^\d{15}$)|(^\d{18}$)|(^\d{20}$)/;
        if(!idReg.test(this.form.khNsrsbh)){
          Toast('税号格式异常')
          return ''
        }
      }
      var reg_email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if(!reg_email.test(this.form.mail)){
        Toast('邮箱格式异常')
        return ''
      }
      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if(this.form.contactNumber===''){
        Toast('商户手机号不能为空')
      }
      if(!reg_tel.test(this.form.contactNumber)){
        Toast('商户手机号格式异常');
        return ''
      }
      if(this.form.landlordTelephone!==''){
        if(!reg_tel.test(this.form.landlordTelephone)){
          Toast('房东手机号格式异常');
          return ''
        }
      }
      this.$axios
          .post("/memberBusiness/customer/updateState",this.form).then((data) => {
        if(data.code==0){
          this.$router.push({ path: "/customerList" });
          Toast('状态修改成功');
        }else{
          Toast('状态修改失败');
        }
      });
    },
    onSubmit(){
      //先判断发票类型
      if(this.form.kpName===''){
        Toast("商铺名称不能为空");
        return ;
      }
      if(this.form.khlx===''){
        Toast("所在行业不能为空");
        return ;
      }
      if(this.form.zcdz===''){
        Toast("客户地址不能为空");
        return ;
      }
      if(this.form.dzXxdz === ''){
        Toast("详细地址不能为空")
        return;
      }
      if(this.form.mail===''){
        Toast("邮箱不能为空");
        return ;
      }
      console.log("standards:"+this.form.standards)
      console.log(this.form.standards==='')
      if(this.form.standards===''){
        Toast("收费标准不能为空")
        return '';
      }
      if(this.form.khlx === ''){
        Toast("客户类型不能为空")
        return;
      }
      if(this.form.khNsrsbh!==''){
        var idReg = /(^\d{15}$)|(^\d{18}$)|(^\d{20}$)/;
        if(!idReg.test(this.form.khNsrsbh)){
          Toast('税号格式异常')
          return ''
        }
      }
      var reg_email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if(!reg_email.test(this.form.mail)){
        Toast('邮箱格式异常')
        return ''
      }
      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if(this.form.contactNumber===''){
        Toast('商户手机号不能为空')
      }
      if(!reg_tel.test(this.form.contactNumber)){
        Toast('商户手机号格式异常');
        return ''
      }
      if(this.form.landlordTelephone!==''){
        if(!reg_tel.test(this.form.landlordTelephone)){
          Toast('房东手机号格式异常');
          return ''
        }
      }
      if(this.xgtj===false){
      this.$axios
          .post("/memberBusiness/customer/add",this.form).then((data) => {
        if(data.code==0){
          this.$router.push({ path: "/customerList" });
          Toast('提交成功');
        }else{
          Toast('提交失败');
        }
      });
    }else{
         this.$axios
            .post("/memberBusiness/customer/update",this.form).then((data) => {
          if(data.code==0){
            this.$router.push({ path: "/customerList" });
            Toast('修改成功');
          }else{
            Toast('修改失败');
          }
        });
      }
    }
}

}
</script>